export class Step3 {
    constructor() {}
    intitule = 'stepper.form.mapa_an.step4';

    getinfosannulation = 'form.mapa_an.getinfosannulation';
}
